import React from 'react';
interface ProjectCardProps {
  title: string;
  image: string;
  logo?: string;
  onClick?: () => void;
}
export function ProjectCard({
  title,
  image,
  logo,
  onClick
}: ProjectCardProps) {
  return <button onClick={onClick} className="flex-shrink-0 w-64 h-40 rounded-xl overflow-hidden relative shadow-sm group cursor-pointer" data-id="element-75">
      <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-76" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-77" />

      {logo && <div className="absolute top-3 left-3 w-8 h-8 bg-white/90 rounded-full p-1.5 flex items-center justify-center" data-id="element-78">
          <img src={logo} alt="logo" className="w-full h-full object-contain" data-id="element-79" />
        </div>}

      <div className="absolute bottom-3 left-3 right-3" data-id="element-80">
        <h3 className="text-white font-bold text-base leading-tight drop-shadow-sm" data-id="element-81">
          {title}
        </h3>
      </div>
    </button>;
}